import { MAPLIBRE_STATION_PIN_POPUP_OFFSET_PX } from "@ryde/controls";

export const LANDING_ADDRESS_MAP_ZOOM = 16;

export const DEFAULT_LANDING_ADDRESS_MAP_WIDTH = "100%";
export const DEFAULT_LANDING_ADDRESS_MAP_HEIGHT = "300px";

/** Screen padding (px) left around the framed markers. */
export const LANDING_ADDRESS_MAP_FIT_PADDING_PX = 48;

/** Height (px) of the home pin asset, which is bottom-anchored and so stands this far above its point. */
export const LANDING_HOME_PIN_HEIGHT_PX = 50;

/** Breathing room between the tallest marker and the popup's tail. */
const LANDING_POPUP_GAP_PX = 4;

/**
 * Lift (px) for a marker's popup, so the card sits above the pin rather than burying it.
 *
 * Both markers are bottom-anchored, so this has to clear the taller of the two. The station pin brings its
 * own figure, derived from its geometry; the home pin is simply its own height plus a gap.
 */
export const LANDING_ADDRESS_MAP_POPUP_OFFSET_PX = Math.max(
  MAPLIBRE_STATION_PIN_POPUP_OFFSET_PX,
  LANDING_HOME_PIN_HEIGHT_PX + LANDING_POPUP_GAP_PX,
);
